// extracted by css-extract-rspack-plugin
export default {"RelativeTime":"Blame-module__RelativeTime__cw7D6AI"};